import React from 'react';
import PropTypes from 'prop-types';
import { Marker, InfoBox } from '@react-google-maps/api';
import styled from 'styled-components';

import unknown from '../../images/dummyPhoto/photo_other.png';
import basePin from '../../images/map/userPin.png';
import ColorSF2 from '../../styles/common/ColorSF2';

const MarkerWrapper = styled.div`
  position: relative;
  width: 100px;
  height: 114px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const LabelWrapper = styled.div`
  width: 100px;
  color: #000;
  font-size: 13px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
const LabelText = styled.span`
  width: 100%;
  border-radius: 5px;
  border: 1px solid #eee;
  background-color: #fff;
  box-shadow: 2px 2px 2px ${ColorSF2.transparentShadow};
  padding: 5px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: relative;
`;

const MapPin = ({ marker, zIndex, onClickMarker }) => {
  const { name, lat, lng } = marker;
  const position = { lat, lng };

  return (
    <MarkerWrapper>
      <InfoBox
        options={{
          disableAutoPan: true,
          closeBoxURL: '',
          pixelOffset: new window.google.maps.Size(-50, -110),
        }}
        position={position}
        zIndex={zIndex}
        onClick={() => onClickMarker(marker.operatorId)}
      >
        <LabelWrapper
          id="MapIconNameWrapper"
          onClick={() => onClickMarker(marker.operatorId)}
        >
          <LabelText>{name}</LabelText>
        </LabelWrapper>
      </InfoBox>
      <Marker
        position={position}
        clickable
        icon={basePin}
        opacity={1.0}
        zIndex={zIndex}
        onClick={() => onClickMarker(marker.operatorId)}
      />
      <Marker
        position={position}
        clickable
        icon={{
          url: unknown,
          anchor: new window.google.maps.Point(21, 72),
          scaledSize: new window.google.maps.Size(43, 43),
        }}
        opacity={1.0}
        zIndex={zIndex}
        onClick={() => onClickMarker(marker.operatorId)}
      />
    </MarkerWrapper>
  );
};

MapPin.propTypes = {
  marker: PropTypes.object.isRequired,
  zIndex: PropTypes.number.isRequired,
  onClickMarker: PropTypes.func.isRequired,
};

export default MapPin;
